export default __webpack_public_path__ + "static/media/erreur.d1384161.png";